import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-formatted-link',
    templateUrl: './formatted-link.component.html',
    styleUrls: ['./formatted-link.component.scss'],
    standalone: false
})
export class FormattedLinkComponent implements OnInit {
  @Input() url: string;
  @Input() text: string;
  @Input() defaultUrl: string;

  constructor() { }

  ngOnInit(): void {
    if(this.defaultUrl !== undefined && this.defaultUrl.length > 0){
      this.url = this.defaultUrl;
      this.text = this.defaultUrl;
    }
  }

}
